/* eslint-disable */
import React, { Component, useContext } from "react";
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Paper,
    Typography,
    Grid,
    CardActions,
    CardMedia
} from '@mui/material';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ListIcon from '@mui/icons-material/List';
import { useTheme } from '@mui/material/styles';
import { useAzureADGroups } from '../msal/useAzureADGroups';


export const DashInfo = () => {
    const theme = useTheme();
    const { canEditCourseAndModule } = useAzureADGroups();
    const isLightTheme = theme.palette.type === 'light';
        const cardStyle = {
            display: 'inline-block',
            marginTop: '20px',
        };
        const containerStyle = {
            display: 'flex',
        };

    const LightStyle = {
        display: 'inline-block',
        marginTop: '20px',
        backgroundColor: '#EFEFEF'
    }
    const DarkStyle = {
        display: 'inline-block',
        marginTop: '20px',
        backgroundColor: '#2F2F2F'
    }
    const halfWidth = {
        width: '50%'
    }
    const thirdWidth = {
        width: '33%'
    }
        return (
            <>
            {canEditCourseAndModule? 
            <>
            <div style={containerStyle}>
                    <Card style={cardStyle} sx={thirdWidth}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Course
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Courses hold all the relevent information for a students studies including modules, deliveries and Learning oucomes.
                            </Typography>
                        </CardContent><CardActions>
                            <Link to="Course/create">
                                <Button size="small" ><AddIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px' }} /> Create </Button>
                            </Link>
                            <Link to="Course">
                                <Button size="small" ><ListIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px', marginRight: '5px' }} /> List </Button>
                            </Link>
                        </CardActions>
                    </Card>
                    <Card style={cardStyle} sx={{ marginLeft: '20px', width: '33%' }}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Course Instance
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Course Instances hold the per year instance data for a course deleivery, of which there can be many per delivery.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Link to="CourseInstance/create">
                                <Button size="small" ><AddIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px' }} /> Create </Button>
                            </Link>
                            <Link to="CourseInstance">
                                <Button size="small" ><ListIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px', marginRight: '5px' }} /> List </Button>
                            </Link>
                        </CardActions>
                    </Card>
                    <Card style={cardStyle} sx={{ marginLeft: '20px', width: '33%' }}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Module
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Modules are the units of study for a course and make up the learning material, they can span accross multiple courses.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Link to="Module/create">
                                <Button size="small" ><AddIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px' }} /> Create </Button>
                            </Link>
                            <Link to="Module">
                                <Button size="small" ><ListIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px', marginRight: '5px' }} /> List </Button>
                            </Link>
                        </CardActions>
                    </Card>
                </div>
                <div style={containerStyle}>
                    <Card style={cardStyle} sx={thirdWidth}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Associate Course
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                A student may study a single module or a few modules that are not part of a course and do not qualify for an award. 
                                These can add up too enough credits for a certificate or diploma or acceptance on to a higher degree course. 
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Link to="AssociateCourse/create">
                                <Button size="small" ><AddIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px' }} /> Create </Button>
                            </Link>
                            <Link to="AssociateCourse">
                                <Button size="small" ><ListIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px', marginRight: '5px' }} /> List </Button>
                            </Link>
                        </CardActions>
                    </Card>
                    <Card style={cardStyle} sx={{ marginLeft: '20px', width: '33%' }}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Research Course
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                A cut down version of a Course mainly used to keep track on non taught qualifications such as MPhil or PHD. 
                                Can still hold deliveries and instances, but holds considerably less information. 
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Link to="ResearchCourse/create">
                                <Button size="small" ><AddIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px' }} /> Create </Button>
                            </Link>
                            <Link to="ResearchCourse">
                                <Button size="small" ><ListIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px', marginRight: '5px' }} /> List </Button>
                            </Link>
                        </CardActions>
                    </Card>
                    <Card style={cardStyle} sx={{ marginLeft: '20px' , width: '33%'}}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Research Module
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Module used to fill a Research Couse, usually a one to one relationship where the course has a specific modules that will fulfil.
                                <br/>
                                <br/>
                            </Typography>
                           
                        </CardContent>
                        <CardActions>
                            <Link to="ResearchModule/create">
                                <Button size="small" ><AddIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px' }} /> Create </Button>
                            </Link>
                            <Link to="ResearchModule">
                                <Button size="small" ><ListIcon fontSize="small" sx={{ marginTop: '-3px', marginLeft: '5px', marginRight: '5px' }} /> List </Button>
                            </Link>
                        </CardActions>
                    </Card>
                </div>
            </> : null
                }
                <div style={containerStyle}>
                    <Card style={theme.palette.mode === 'dark' ? DarkStyle : LightStyle} sx={halfWidth}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Introduction to Vero - Connect Pages
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Welcome to the new home for Curriculum information at the University of South Wales,
                                to learn more about this application and what it is used for please follow the link on this card.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Link to="https://universityofsouthwales.sharepoint.com/sites/Vero" target="_blank" rel="noopener noreferrer">
                                <Button size="small">Learn More</Button>
                            </Link>
                        </CardActions>
                    </Card>
                    <Card style={theme.palette.mode === 'dark' ? DarkStyle : LightStyle} sx={{ marginLeft: '20px', width: '50%' }}>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="div" color="secondary">
                                Troubleshooting with Vero Champions
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                If you have a query about the new system that you weren't able to find an answer for on the connect pages.
                                The Vero champions are members of staff that are available to answer and queries with how to use Vero if you are unsure.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Link style={{ color: 'inherit', textDecoration: 'inherit'}} to="mailto:verosupport@southwales.ac.uk" >
                                <Typography variant="body2" color="secondary" sx={{ marginLeft: '10px' }}>verosupport@southwales.ac.uk</Typography>
                            </Link>
                        </CardActions>
                    </Card>
                    
                </div>
                <br></br>
                <br></br>
                <br></br>

            </>

        );
    
}

export default DashInfo;